import styles from "../../../../styles/finder/finder.module.scss"
import Image from "next/image"
import { useEffect, useState } from "react"
import CheckBox from "../../checkbox/checkbox"
import { STEPS, useUserStore, useWizardStore } from "../store/finder_store"
import { haversineDistance, parseCoordinates } from "../store/nominatim"
import StyledText from "../../../typography/typography-component"
import skColors from "../../../../styles/skColors"
import Button from "../../Button/Button"
import { useTranslations } from "next-intl"
import { doctors, GermanStates } from "../data/doctors"

const Step3c = () => {
  const t = useTranslations("index.finder")

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className={styles.step3Content}>
      <StyledText variant="h3" color={skColors.turquoise[600]}>
        {t("step1.title")}
      </StyledText>

      <div className={styles.descriptionWrapper}>
        <StyledText variant="pRegular">
          {t("step3c.description")} {t("step3c.description2")}
        </StyledText>
      </div>
      <div
        style={{
          marginTop: "24px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <div className={styles.mailImageWrapper}>
          <Image
            src={"/svg/mail_image.svg"}
            alt={"mail was sent"}
            width={328}
            height={217}
            className={styles.mailImage}
          />
        </div>
      </div>
    </div>
  )
}

export default Step3c
